module.exports = __webpack_public_path__ + "static/media/cb.3d8f827a.jpg";